<template>
  <section class="hero">
    <div class="hero__inner">
      <div class="hero__copy">
        <h1 class="hero__title">
          <span class="hero__main">
            MÁS FUERZA<br />
            MÁS CONTROL<br />
            MÁS SEGURIDAD
          </span>
        </h1>

        <p class="hero__subtitle">
          Información lista cuando el<br />
          movimiento no se detiene
        </p>
      </div>

      <div class="hero__mujer">
        <img src="../assets/IMG/Mujer.png" alt="Mujer" />
      </div>
    </div>

    <div class="hero__bottom-line"></div>
  </section>
</template>

<script>
export default {
  name: "WelcomeView",
};
</script>

<style scoped>
.hero {
  position: relative;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  margin-top: 86px;
  overflow: hidden;

  min-height: clamp(590px, 63vw, 880px);

  background-color: #000;
  background-image: url("../assets/IMG/Difuminado.png");
  background-repeat: no-repeat;
  background-position: center -70px;
  background-size: 100% 100%;

  padding-left: 8vw;
  padding-right: 8vw;
}

.hero__inner {
  position: relative;
  width: 100%;
  min-height: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: clamp(22px, 3.2vw, 54px) clamp(10px, 2.8vw, 38px);
}

.hero__copy {
  position: relative;
  z-index: 3;
  width: min(760px, 52%);
  text-align: left;
}

.hero__title {
  margin: 0;
  line-height: 0.95;
  text-transform: uppercase;
}

.hero__main {
  display: inline-block;
  font-family: "Barlow", sans-serif;
  font-size: clamp(42px, 6vw, 96px);
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #c8f34b;
  line-height: 1.02;
}

.hero__subtitle {
  margin: 22px 0 0;
  font-family: "Barlow", sans-serif;
  font-size: clamp(18px, 2vw, 32px);
  font-weight: 400;
  line-height: 1.15;
  color: #ffffff;
  max-width: 520px;
}

.hero__mujer {
  position: absolute;
  right: -230px;
  bottom: 80px;
  top: auto;
  height: calc(100% - 80px);
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  z-index: 2;
  width: 40vw;
}

.hero__mujer img {
  display: block;
  height: 100%;
  width: auto;
  max-height: 95%;
  object-fit: contain;
}

.hero__bottom-line {
  width: 100vw;
  height: 80px;
  background: #c8f34b;
  position: absolute;
  left: 50%;
  bottom: 0;
  margin-left: -50vw;
  z-index: 10;
}

/* ===== DESKTOP MEDIO ===== */
@media (max-width: 1200px) {
  .hero {
    min-height: clamp(520px, 66vw, 760px);
    padding-left: 6vw;
    padding-right: 6vw;
  }

  .hero__copy {
    width: min(620px, 55%);
  }

  .hero__main {
    font-size: clamp(38px, 5.6vw, 78px);
  }

  .hero__subtitle {
    font-size: clamp(17px, 2vw, 26px);
    max-width: 420px;
  }

  .hero__mujer {
    width: min(44vw, 620px);
    right: -6vw;
  }
}

/* ===== TABLET GENERAL ===== */
@media (min-width: 768px) and (max-width: 1024px) {
  .hero {
    margin-top: 78px;
    min-height: 680px;
    padding-left: 5vw;
    padding-right: 5vw;
    background-position: center;
    background-size: cover;
  }

  .hero__inner {
    align-items: center;
    justify-content: space-between;
    padding: 28px 16px;
  }

  .hero__copy {
    width: 52%;
    text-align: left;
  }

  .hero__main {
    font-size: clamp(42px, 6.2vw, 72px);
    line-height: 0.98;
  }

  .hero__subtitle {
    margin-top: 18px;
    font-size: clamp(18px, 2.3vw, 24px);
    max-width: 340px;
  }

  .hero__mujer {
    right: -10vw;
    width: min(50vw, 520px);
    height: 96%;
  }

  .hero__mujer img {
    max-height: 100%;
  }
}

/* ===== MÓVIL GENERAL ===== */
@media (max-width: 767px) {
  .hero {
    margin-top: 72px;
    min-height: 88svh;
    height: 88svh;
    padding-left: 0;
    padding-right: 0;
    background-position: center -24px;
    background-size: cover;
  }

  .hero__inner {
    height: 100%;
    min-height: 0;
    padding: 28px 16px 0;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .hero__copy {
    width: min(92%, 560px);
    text-align: center;
    z-index: 4;
  }

  .hero__main {
    font-size: clamp(28px, 8vw, 42px);
    line-height: 1.02;
    color: #c8f34b;
  }

  .hero__subtitle {
    margin: 14px auto 0;
    font-size: clamp(14px, 4.2vw, 20px);
    line-height: 1.2;
    max-width: 26ch;
    color: #ffffff;
  }

  .hero__mujer {
    position: absolute;
    left: 50%;
    right: auto;
    bottom: 26px;
    transform: translateX(-50%);
    width: 126vw;
    height: 60%;
    justify-content: center;
    align-items: flex-end;
    z-index: 2;
  }

  .hero__mujer img {
    width: auto;
    height: 100%;
    max-height: none;
    object-fit: contain;
  }

  .hero__bottom-line {
    height: 58px;
  }
}

/* ===== MÓVILES PEQUEÑOS ===== */
@media (max-width: 480px) {
  .hero {
    min-height: 90svh;
    height: 90svh;
    background-position: center -30px;
  }

  .hero__inner {
    padding-top: 34px;
  }

  .hero__main {
    font-size: clamp(26px, 8.4vw, 38px);
  }

  .hero__subtitle {
    font-size: clamp(13px, 4vw, 17px);
    max-width: 24ch;
  }

  .hero__mujer {
    width: 136vw;
    height: 58%;
    bottom: 18px;
  }
}

/* ===== 360 a 389 ===== */
@media (min-width: 360px) and (max-width: 389px) {
  .hero__copy {
    margin-top: 12px;
  }

  .hero__mujer {
    width: 140vw;
    height: 59%;
    bottom: 16px;
  }
}

/* ===== 390 a 413 ===== */
@media (min-width: 390px) and (max-width: 413px) {
  .hero__copy {
    margin-top: 18px;
  }

  .hero__mujer {
    width: 142vw;
    height: 60%;
    bottom: 18px;
  }
}

/* ===== 414 a 430 ===== */
@media (min-width: 414px) and (max-width: 430px) {
  .hero__copy {
    margin-top: 26px;
  }

  .hero__mujer {
    width: 148vw;
    height: 62%;
    bottom: 20px;
  }
}

/* ===== 412 x 915 ===== */
@media (width: 412px) and (height: 915px) {
  .hero {
    background-position: center -36px;
  }

  .hero__copy {
    margin-top: 70px;
  }

  .hero__mujer {
    width: 150vw;
    height: 63%;
    bottom: 24px;
  }
}

/* ===== 430 x 932 aprox ===== */
@media (min-width: 428px) and (max-width: 430px) and (min-height: 920px) {
  .hero {
    background-position: center -40px;
  }

  .hero__mujer {
    width: 152vw;
    height: 64%;
    bottom: 24px;
  }
}

/* ===== iPhone XR / 11 / 11 Pro Max aprox ===== */
@media (min-width: 414px) and (max-width: 430px) and (min-height: 850px) {
  .hero__mujer {
    bottom: 26px;
    height: 63%;
  }
}

/* =========================
   iPad Mini vertical
   768 x 1024
========================= */
@media (width: 768px) and (height: 1024px) {
  .hero {
    margin-top: 78px;
    min-height: 720px;
    background-size: cover;
    background-position: center top;
    padding-left: 5vw;
    padding-right: 5vw;
  }

  .hero__inner {
    padding: 28px 18px;
  }

  .hero__copy {
    width: 62%;
    margin-top: -152px;
  }

  .hero__main {
    font-size: clamp(46px, 6vw, 68px);
    line-height: 0.98;
  }

  .hero__subtitle {
    font-size: clamp(18px, 2.1vw, 24px);
    max-width: 330px;
    margin-top: 16px;
  }

  .hero__mujer {
    width: 32vw;
    height: 70%;
    right: -16vw;
    bottom: 80px;
  }

  .hero__bottom-line {
    height: 72px;
  }
}

/* =========================
   iPad Air vertical
   820 x 1180
========================= */
@media (width: 820px) and (height: 1180px) {
  .hero {
    margin-top: 80px;
    min-height: 780px;
    background-size: cover;
    background-position: center top;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }

  .hero__inner {
    padding: 30px 20px;
  }

  .hero__copy {
    width: 60%;
    margin-top: -120px;
  }

  .hero__main {
    font-size: clamp(50px, 6.3vw, 72px);
    line-height: 0.98;
  }

  .hero__subtitle {
    margin-top: 18px;
    font-size: clamp(19px, 2.2vw, 25px);
    max-width: 350px;
  }

  .hero__mujer {
    width: 34vw;
    height: 73%;
    right: -30vw;
    bottom: 80px;
  }

  .hero__mujer img {
    height: 100%;
    width: auto;
  }

  .hero__bottom-line {
    height: 74px;
  }
}

/* =========================
   Surface Pro 7 vertical
   912 x 1368
========================= */
@media (width: 912px) and (height: 1368px) {
  .hero {
    margin-top: 82px;
    min-height: 860px;
    background-size: cover;
    background-position: center top;
    padding-left: 6vw;
    padding-right: 6vw;
  }

  .hero__inner {
    padding: 34px 22px;
  }

  .hero__copy {
    width: 58%;
    margin-top: -110px;
  }

  .hero__main {
    font-size: clamp(54px, 6vw, 78px);
    line-height: 0.97;
  }

  .hero__subtitle {
    margin-top: 18px;
    font-size: clamp(21px, 2.1vw, 28px);
    max-width: 380px;
  }

  .hero__mujer {
    width: 33vw;
    height: 72%;
    right: -30vw;
    bottom: 80px;
  }

  .hero__mujer img {
    height: 100%;
    width: auto;
  }

  .hero__bottom-line {
    height: 76px;
  }
}

/* =========================
   iPad Pro 12.9 vertical
   1024 x 1366
========================= */
@media (width: 1024px) and (height: 1366px) {
  .hero {
    margin-top: 86px;
    min-height: 820px;
    padding-left: 7vw;
    padding-right: 7vw;
    background-position: center center;
    background-size: cover;
  }

  .hero__inner {
    padding: 36px 24px;
    align-items: center;
    justify-content: space-between;
  }

  .hero__copy {
    width: 54%;
    text-align: left;
    margin-top: -40px;
  }

  .hero__main {
    font-size: clamp(54px, 5vw, 78px);
    line-height: 0.97;
  }

  .hero__subtitle {
    margin-top: 18px;
    font-size: clamp(22px, 2.1vw, 30px);
    max-width: 400px;
  }

  .hero__mujer {
    right: -18vw;
    left: auto;
    transform: none;
    width: 36vw;
    height: 74%;
    bottom: 80px;
  }

  .hero__mujer img {
    height: 100%;
    width: auto;
  }

  .hero__bottom-line {
    height: 80px;
  }
}
</style>